import { Component } from '@angular/core';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { GraphService } from '../../General/graph/graph.service';
import { TeacherGraphExerciseComponent } from '../../shared/interactive-graph/exercise_components/teacher-graph-exercise.component';
import { InteractiveGraph } from 'graph-interactive/dist/lib/interactive/interactiveGraph';
import { SimpleInteractiveDirectedGraph, GraphAlgorithm, GraphServiceJson, GraphRandom } from 'graph-interactive';
import { GraphDW } from '../../shared/interactive-graph/simple_graphs/graphDW';

@Component({
  selector: 'app-t-shortest-path',
  templateUrl: './t-shortest-path.component.html',
  styleUrls: ['./t-shortest-path.component.css']
})
export class TShortestPathComponent extends TeacherGraphExerciseComponent {

  private readonly canvasID: string = 'graph-canvas';
  private readonly solutionID: string = 'solutionButton';

  constructor(protected topicsService: TopicService, protected activatedRoute: ActivatedRoute, graphService: GraphService) {
    super(topicsService, activatedRoute);
    this.type = 'shortestPath';
    this.title = this.get('shortestPath');
    this.description = this.get('descriptionShortestPath');
  }


  generate(){
    GraphRandom.generateGraph(this.graph,true);
  }
  // tslint:disable-next-line: use-life-cycle-interface
  ngOnInit() {
    super.ngOnInit();
    window.onload = function () { };

    const button = <HTMLButtonElement>document.getElementById(this.solutionID);
    button.addEventListener('click', this.onShowSolution, false);
  }

  initGraph(): InteractiveGraph {
    const canvas = <HTMLCanvasElement>document.getElementById(this.canvasID);
    return new GraphDW(canvas);
  }

  onShowSolution = () => {
    this.showSolution();
  }

  showSolution() {
    const sol = GraphAlgorithm.dijkstraShortestPath(this.graph.getGraph(),
      this.graph.getSourceNode(), this.graph.getTargetNode());
    this.graph.highLight(sol[0], sol[1]);
  }

  generateDefinition(): any {

    const definition: any = {};
    // tslint:disable-next-line: triple-equals
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = './assets/images/optimalSolutions.png';
    definition.key = 'optimalSolutions%'.concat(this.type, '%' + this.id);
    if (this.examId > -1) {
      definition.key = definition.key.concat('exam%', this.examId.toString(), '%');
    }
    GraphServiceJson.exportGraph(this.graph, definition);
    return definition;
  }




}







